import { AppShell } from './components/AppShell';

/** Application root. The full three-column chrome lives in {@link AppShell}. */
export function App() {
  return <AppShell />;
}
